export default __webpack_public_path__ + "static/media/mob-detail-1.c79ad7bc.webp";